import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Alert, ModalComp } from "../";
import { withRouter } from "react-router-dom";
import { ScenariosWidgets } from "./ScenariosWidgets";
import { useTranslation } from "react-i18next";
const ScenariosZone = (props) => {
  const { t } = useTranslation();
  const { title, icon, setScenarioCommand, scenarioId } = props;

  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [zoneIndex, setZoneIndex] = useState();
  const [zoneId, setZoneId] = useState();
  const token = Cookies.get("token");
  const [zoneCaption, setZoneCaption] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [openScenariosWidgets, setOpenScenariosWidgets] = useState(false);
  const toggleScenariosWidgets = () => {
    setOpenScenariosWidgets(!openScenariosWidgets);
  };

  const zoneClicked = (value, index) => {
    setZoneCaption(value.zone_caption);
    setZoneIndex(index);
    setZoneId(value.id);
    setOpenScenariosWidgets(true);
  };

  //   const relocateWidgetClicked = () => {
  //     const data = new FormData();
  //     data.append("serial", zone.serial);
  //     data.append("widget", zone.id);
  //     data.append("zone", zoneId);
  //     relocateWidget(data, token)
  //       .then(() => {
  //         setShowAlert((prevState) => ({
  //           ...prevState,
  //           show: true,
  //           message: "ویجت با موفقیت منتقل شد.",
  //           type: "Success",
  //         }));
  //         setTimeout(() => {
  //           setShowAlert((prevState) => ({
  //             ...prevState,
  //             show: false,
  //           }));
  //           toggleMove();
  //           dispatch(relocateZoneWidget(zone));
  //         }, 2000);
  //       })
  //       .catch((err) => {
  //         if (err.response.status === 403) {
  //           Cookies.remove("token");
  //           props.history.push("/login");
  //         }
  //       });
  //   };

  return (
    <>
      <ModalComp
        modal={openScenariosWidgets}
        toggle={toggleScenariosWidgets}
        component={
          <ScenariosWidgets
            id={zoneId}
            setScenarioCommand={setScenarioCommand}
            scenarioId={scenarioId}
            zoneCaption={zoneCaption}
          />
        }
      />
      <div className="text-right">
        <div className="d-flex justify-content-center my-3  ">
          <div className="d-flex flex-column align-items-center gap-3  ">
            <small>
              {t("ناحیه ای که دستگاه شما در آن قرار دارد را انتخاب نمایید.")}
            </small>
            <small
              className="addScenarioIcon rounded-circle d-block py-1
             text-center  border-0 "
            >
              <i className={`${icon}  text-white  `}></i>
            </small>

            <div className="text-center mt-2">
              <p className="m-0"> {title}</p>
            </div>
          </div>
        </div>
        <div className="my-4" style={{ minHeight: "80vh" }}>
          {dashboardZones?.map((zone, index) => {
            let active = zoneIndex === index ? "selectZonesActive" : "";
            return (
              <div
                className={`selectZones text-center py-3 my-2 cursor ${active}`}
                key={index}
                onClick={() => zoneClicked(zone, index)}
              >
                <p className="m-0 fn">{zone.zone_caption}</p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const ScenariosZones = withRouter(ScenariosZone);

export { ScenariosZones };
